import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, IonInput } from '@ionic/angular/lazy';
import { CartService } from 'src/app/services/cart.service';
import { Decimal } from 'decimal.js';

@Component({
    selector: 'app-checkout-payment-cheque',
    templateUrl: './checkout-payment-cheque.page.html',
    styleUrls: ['./checkout-payment-cheque.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutPaymentChequePage implements OnInit {

    cart = null;
    payment = {
        method: 'cheque',
        price: null,
        label:'Cheque'
    };
    payment_amount = 0;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService
    ) { }

    ngOnInit() {
        this.cartService.get().then((cart) => {
            if (cart) {
                this.cart = cart;
                this.payment_amount = cart['amount_due'].toFixed(2);
                this.payment.price = cart['amount_due'];
            }
        });
    }

    sanitisePaymentAmount() {

        let payment_amount = this.payment_amount.toString();
        
        // only accept numbers/decimal points
        if(/[^0-9.]/.test(payment_amount)) {
            this.payment.price = null;
        }        
        else if(payment_amount.startsWith('.')) {
            this.payment.price = null;
        }
        else if(payment_amount.endsWith('.')) {
            this.payment.price = null;
        }              
        else if(payment_amount.split('.').length > 2) {
            this.payment.price = null;
        }
        else if(!payment_amount.length) {
            this.payment.price = null;
        }
        else {
            this.payment.price = Number(new Decimal(payment_amount).toDecimalPlaces(2));
        }

    }

    addPayment() {
    
        // ensure payment isn't over the amount due
        if(this.payment.price > this.cart.amount_due) {
            this.payment.price = this.cart.amount_due;
        }

        this.cartService.addPayment(this.payment).then(() => {
            this.modalController.dismiss();
        });

    }

    close() {
        this.modalController.dismiss();
    }

}
